import { reportErrorToSentry } from "@/zapi-frontend/utils/report-error-to-sentry";
import { ParsedContent } from "../ChatMessage";
import { getErrorConfig } from "@/zapi-frontend/shared/config/errorMessages";

// TODO: May need stronger typing here
export const parseMessageContent = (content: string, isLabsMode = false): ParsedContent => {
  const defaultErrorContent: ParsedContent = {
    type: "error",
    content: "There was an error processing this message"
  };

  if (content.length === 0) return defaultErrorContent;

  try {
    const cleanContent = content.trim();
    let parsed;

    try {
      parsed = JSON.parse(cleanContent);
    } catch (e) {
      // Log original error in labs mode
      if (isLabsMode) {
        console.error("[CORRUPTED_JSON] Original parsing error:", e);
        console.error("[CORRUPTED_JSON] Content that failed to parse:", cleanContent);
      }

      // In case LLM added some extra text
      const jsonMatch = cleanContent.match(/\{[\s\S]*\}/);
      if (!jsonMatch || jsonMatch.length === 0) {
        const errorConfig = getErrorConfig("JSON parse error", isLabsMode);
        return { type: "error", content: errorConfig.userMessage };
      }
      try {
        parsed = JSON.parse(jsonMatch[0]);
      } catch (innerError) {
        const errorConfig = getErrorConfig("JSON parse error", isLabsMode);
        return { type: "error", content: errorConfig.userMessage };
      }
    }

    if (!parsed || typeof parsed !== "object" || !parsed.type || typeof parsed.content !== "string") {
      // Log invalid format in labs mode
      if (isLabsMode) {
        console.error("[INVALID_FORMAT] Parsed content:", parsed);
      }
      const errorConfig = getErrorConfig("Invalid message format", isLabsMode);
      reportErrorToSentry(errorConfig.userMessage, "parseMessageContent", "invalidMessageFormat", {
        extra: {
          parsed: parsed
        }
      });
      return { type: "error", content: errorConfig.userMessage };
    }

    const validTypes = ["answer", "websearch", "error", "warning", "updateChapter", "answerAndUpdate", "multiAction", "agent", "prereqSummary"];
    if (!validTypes.includes(parsed.type)) parsed.type = "answer";

    return {
      type: parsed.type as ParsedContent["type"],
      content: parsed.content,
      notes: Array.isArray(parsed.notes) ? parsed.notes : undefined,
      actions: Array.isArray(parsed.actions) ? parsed.actions : undefined,
      agentType: parsed.agentType,
      chapterName: typeof parsed.chapterName === "string" ? parsed.chapterName : undefined,
      chapters: Array.isArray(parsed.chapters) ? parsed.chapters : undefined
    };
  } catch (e) {
    // Log unexpected error in labs mode
    if (isLabsMode) {
      console.error("[UNEXPECTED_ERROR] Parsing error:", e);
    }
    const errorConfig = getErrorConfig("Unexpected parsing error", isLabsMode);
    return { type: "error", content: errorConfig.userMessage };
  }
};
